/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface MgmMilestoneConfigDTO {
  defaultImageUrl?: string;
  displayImageUrl?: string;
  displayTitle?: string;
  editable?: boolean;
  glampoints?: number;
  inStockReserveMarketing?: number;
  internalEan?: string;
  isActive?: boolean;
  milestoneNumber?: number;
  milestoneType?: string;
  productVariantId?: number;
  productVariantName?: string;
  sortOrder?: number;
  thresholdValue?: number;
}
